import { render, staticRenderFns } from "./DSearchFieldsMini.vue?vue&type=template&id=0d86e4bb&scoped=true&lang=pug"
import script from "./DSearchFieldsMini.vue?vue&type=script&lang=js"
export * from "./DSearchFieldsMini.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d86e4bb",
  null
  
)

export default component.exports